import { getReceiptPartidas } from "../services/Rest.jsx";
import useFetch from "./useFetch";

const useReceiptPartidas = (receiptId) => {
  return useFetch(getReceiptPartidas, true, receiptId);
};

export default useReceiptPartidas;
